import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class TicketService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.TICKET = '/api/ticket';
        
        this.GET_BY_ID = '/{id}';
        this.GET_LIST_BY_PROJECT_ID = '/list/project/{projectId}';
        this.GET_LIST_BY_PROJECT_ID_PAGE_SORT_FILTER = '/list/project/{projectId}';
        this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID = '/list/type/{createdByType}/id/{createdById}';
        this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID_AND_UNRESOLVED = '/list/unresolved/type/{createdByType}/id/{createdById}';
        this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID_AND_PROJECT_ID = '/list/type/{createdByType}/id/{createdById}/project/{projectId}';

        this.GET_TICKET_BY_TICKET_ID = "/ticket/{ticketId}";
        this.GET_ANALYSIS_BY_PROJECT = "/analysis/project/{projectId}";
        this.SEARCH_BY_KEYWORD_AND_PROJECT_ID = '/list/search/keyword{keyword}/project/{projectId}';
        this.UPDATE_TICKET_STATUS = '/update/status';
        this.ADD_CLIENT_COMMENT = '/add/client-comment';

    }

    async getTicket(id) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketByTicketId(ticketId) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_TICKET_BY_TICKET_ID;
            url = url
                .replace('{ticketId}', ticketId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByProjectId(projectId) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_LIST_BY_PROJECT_ID;
            url = url
                .replace('{projectId}', projectId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByProjectIdSortedAndFiltered(projectId, page, size, sortBy, order, filterBy, filterValue, statusList) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_LIST_BY_PROJECT_ID_PAGE_SORT_FILTER;
            url = url
                .replace('{projectId}', projectId);
            url = url + '?page=' + page + '&size=' + size + '&sortBy=' + sortBy + '&order=' + order + '&filterBy=' + filterBy + '&filterValue=' + filterValue + '&statusList=%5B' + statusList + '%5D';
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByCreatedByTypeAndCreatedById(createdByType, createdById) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID;
            url = url
                .replace('{createdByType}', createdByType)
                .replace('{createdById}', createdById)
            const ticketDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByCreatedByTypeAndCreatedByIdAndUnresolved(createdByType, createdById) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID_AND_UNRESOLVED;
            url = url
                .replace('{createdByType}', createdByType)
                .replace('{createdById}', createdById)
            const ticketDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByCreatedByTypeAndCreatedByIdAndProjectId(createdByType, createdById, projectId, page, size, sortBy, order, filterBy, filterValue, statusList) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID_AND_PROJECT_ID;
            url = url
                .replace('{createdByType}', createdByType)
                .replace('{createdById}', createdById)
                .replace('{projectId}', projectId);
            url = url + '?page=' + page + '&size=' + size + '&sortBy=' + sortBy + '&order=' + order + '&filterBy=' + filterBy + '&filterValue=' + filterValue + '&statusList=%5B' + statusList + '%5D';
            const ticketDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getAnalysisInProject(projectId) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_ANALYSIS_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async searchTicketListByKeywordInProject(keyword, projectId) {
        try {
            let url = window.location.origin + this.TICKET + this.SEARCH_BY_KEYWORD_AND_PROJECT_ID;
            url = url
                .replace('{keyword}', keyword)
                .replace('{projectId}', projectId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async updateTicketStatus(updateTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET + this.UPDATE_TICKET_STATUS;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async addClientComment(updateTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET + this.ADD_CLIENT_COMMENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createTicket(ticket) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(ticket)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTicket(ticket) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(ticket)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteTicket(deleteTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(deleteTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default TicketService;
